import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface TutorialDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  isRTL: boolean;
}

const TutorialDrawer: React.FC<TutorialDrawerProps> = ({ isOpen, onClose, isRTL }) => {
  const { t } = useTranslation();
  const [selectedImg, setSelectedImg] = useState<string | null>(null);

  if (!isOpen) return null;

  return (
    <>
      <div style={overlayStyle} onClick={onClose}>
        <div 
          style={{
            ...drawerStyle, 
            left: isRTL ? 'unset' : '0', 
            right: isRTL ? '0' : 'unset',
            direction: isRTL ? 'rtl' : 'ltr'
          }} 
          onClick={(e) => e.stopPropagation()}
        >
          {/* HEADER */}
          <div style={headerStyle}>
            <h2 style={{fontSize: '1.1rem', margin: 0}}>📚 {t('help_center')}</h2>
            <button onClick={onClose} style={closeBtn}>×</button>
          </div>

          <div style={contentStyle}>
            
            {/* ÉTAPE 0 : CRÉATION ÉCOLE */}
            <details style={sectionStyle} open>
              <summary style={summaryStyle}>🏢 {t('tuto_step0_title')}</summary>
              <div style={innerStyle}>
                <div dangerouslySetInnerHTML={{ __html: t('tuto_step0_text') }} />
                <img 
                  src="/Screenshots/web_registration.png" 
                  alt="Registration" 
                  style={{...imgStyle, cursor: 'zoom-in'}} 
                  onClick={() => setSelectedImg("/Screenshots/web_registration.png")}
                />
              </div>
            </details>

            {/* ÉTAPE 1 : ADMIN - GESTION ÉLÈVES & ACCÈS */}
            <details style={sectionStyle}>
              <summary style={summaryStyle}>👤 {t('tuto_step1_title')}</summary>
              <div style={innerStyle}>
                <div style={{marginBottom: '10px'}}>
                  <strong>{t('tuto_admin_eleves_label')} :</strong> 
                  <span dangerouslySetInnerHTML={{ __html: t('tuto_admin_eleves_text') }} />
                </div>
                <img 
                  src="/Screenshots/admin_mail_icon.png" 
                  alt="Mail Icon" 
                  style={{...imgStyle, cursor: 'zoom-in'}} 
                  onClick={() => setSelectedImg("/Screenshots/admin_mail_icon.png")}
                />
                
                {/* ORDRE CORRIGÉ : PRÉSENCE AVANT LA MAP */}
                <div style={{marginTop: '15px', marginBottom: '10px'}}>
                  <strong>{t('tuto_presence_label', 'Rapport de Présence')} :</strong> 
                  <div>{t('tuto_presence_text', 'Suivez l’assiduité en temps réel et exportez les rapports de montée/descente.')}</div>
                </div>
                <img 
                  src="/Screenshots/liste de presence.png" 
                  alt="Presence List" 
                  style={{...imgStyle, cursor: 'zoom-in'}} 
                  onClick={() => setSelectedImg("/Screenshots/liste de presence.png")}
                />

                <div style={{marginTop: '15px', marginBottom: '10px', borderTop: '1px solid #eee', paddingTop: '10px'}}>
                  <strong>{t('tuto_admin_bus_label')} :</strong> 
                  <span dangerouslySetInnerHTML={{ __html: t('tuto_admin_bus_text') }} />
                </div>
                
                <div style={{marginBottom: '10px'}}>
                  <strong>{t('tuto_admin_gps_label')} :</strong> 
                  <span dangerouslySetInnerHTML={{ __html: t('tuto_admin_gps_text') }} />
                </div>
                <img 
                  src="/Screenshots/admin_map_live.png" 
                  alt="Admin Map" 
                  style={{...imgStyle, cursor: 'zoom-in'}} 
                  onClick={() => setSelectedImg("/Screenshots/admin_map_live.png")}
                />
              </div>
            </details>

            {/* ÉTAPE 2 : PARENTS (APP) */}
            <details style={sectionStyle}>
              <summary style={summaryStyle}>👪 {t('tuto_step2_title')}</summary>
              <div style={innerStyle}>
                <div style={{marginBottom: '8px'}} dangerouslySetInnerHTML={{ __html: t('tuto_parent_login') }} />
                
                <div style={badgeApp}>{t('free_version')}</div>
                <ul style={listStyle}>
                  <li dangerouslySetInnerHTML={{ __html: t('notif_presence') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('notif_350m') }} />
                </ul>
                
                <div style={badgePro}>{t('pro_version_with_price', "Version PRO (3,90€/an)")}</div>
                <ul style={listStyle}>
                  <li dangerouslySetInnerHTML={{ __html: t('pro_google_maps') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('pro_eta') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('pro_start') }} />
                </ul>
                <img 
                  src="/Screenshots/app_parent_pro.png" 
                  alt="App Parent" 
                  style={{...imgMobileStyle, cursor: 'zoom-in'}} 
                  onClick={() => setSelectedImg("/Screenshots/app_parent_pro.png")}
                />
              </div>
            </details>

            {/* ÉTAPE 3 : CONDUCTEUR (APP) */}
            <details style={sectionStyle}>
              <summary style={summaryStyle}>🚌 {t('tuto_step3_title')}</summary>
              <div style={innerStyle}>
                <div dangerouslySetInnerHTML={{ __html: t('tuto_driver_sync') }} />
                <ul style={listStyle}>
                  <li dangerouslySetInnerHTML={{ __html: t('driver_checkin') }} />
                  <li dangerouslySetInnerHTML={{ __html: t('driver_tracking') }} />
                </ul>
                <img 
                  src="/Screenshots/app_driver_check.png" 
                  alt="App Driver" 
                  style={{...imgMobileStyle, cursor: 'zoom-in'}} 
                  onClick={() => setSelectedImg("/Screenshots/app_driver_check.png")}
                />
              </div>
            </details>
                        {/* ÉTAPE 4 : HORAIRES & ACTUALISATION BUS */}
            <details style={sectionStyle}>
              <summary style={summaryStyle}>⏰ {t('tuto_bus_schedule_title')}</summary>
              <div style={innerStyle}>
                <div dangerouslySetInnerHTML={{ __html: t('tuto_bus_schedule_desc') }} />
                
                <ul style={listStyle}>
                  <li>🌅 <strong>{t('trip_morning')}</strong> : {t('trip_morning_hours')}</li>
                  <li>☀️ <strong>{t('trip_noon')}</strong> : {t('trip_noon_hours')}</li>
                  <li>🌤️ <strong>{t('trip_afternoon')}</strong> : {t('trip_afternoon_hours')}</li>
                  <li>🌙 <strong>{t('trip_evening')}</strong> : {t('trip_evening_hours')}</li>
                </ul>
                
                <div style={{marginTop: '10px', fontStyle: 'italic', fontSize: '12px', color: '#666'}}>
                  ⚠️ {t('trip_overlap_note')}
                </div>

                <div style={{marginTop: '15px', padding: '10px', backgroundColor: '#e0f2fe', borderRadius: '8px'}}>
                  <strong>🔄 {t('tuto_update_title')}</strong>
                  <div style={{marginTop: '5px'}} dangerouslySetInnerHTML={{ __html: t('tuto_update_desc') }} />
                </div>

                <div style={{marginTop: '10px', padding: '10px', backgroundColor: '#e6fffa', borderRadius: '8px', borderLeft: '4px solid #38b2ac'}}>
                  <strong>🎓 {t('free_schools_title')}</strong>
                  <div style={{marginTop: '5px'}} dangerouslySetInnerHTML={{ __html: t('free_schools_text') }} />
                </div>
              </div>
            </details>

            {/* DOWNLOAD LINKS (CSV) */}
            <div style={{marginTop: '20px', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'center'}}>
   <a href="/models/modele_eleves.csv" download style={xlsLinkStyle}>
       {t('download_xls_eleves') || 'Template élèves'} (.CSV)
   </a>
   <a href="/models/modele_bus.csv" download="modele_bus.csv" style={xlsLinkStyle}>
       {t('download_xls_bus') || 'Template bus'} (.CSV)
   </a>
</div>
          </div>
        </div>
      </div>

      {/* MODAL DE ZOOM */}
      {selectedImg && (
        <div 
          style={modalStyle} 
          onClick={(e) => {
            e.stopPropagation();
            setSelectedImg(null);
          }}
        >
          <img 
            src={selectedImg} 
            style={fullImgStyle} 
            alt="Zoom" 
            onClick={(e) => e.stopPropagation()} 
          />
          <span style={closeZoom}>×</span>
        </div>
      )}
    </>
  );
};

export default TutorialDrawer;

// --- STYLES ---
const overlayStyle: React.CSSProperties = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10000 };
const drawerStyle: React.CSSProperties = { position: 'absolute', top: 0, bottom: 0, width: '340px', backgroundColor: 'white', display: 'flex', flexDirection: 'column', boxShadow: '2px 0 15px rgba(0,0,0,0.3)' };
const headerStyle: React.CSSProperties = { padding: '15px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#2d3748', color: 'white' };
const closeBtn: React.CSSProperties = { background: 'none', border: 'none', color: 'white', fontSize: '26px', cursor: 'pointer' };
const contentStyle: React.CSSProperties = { flex: 1, overflowY: 'auto', padding: '15px' };
const sectionStyle: React.CSSProperties = { marginBottom: '15px', border: '1px solid #e2e8f0', borderRadius: '10px', backgroundColor: '#f8fafc', overflow: 'hidden' };
const summaryStyle: React.CSSProperties = { padding: '12px', fontWeight: 'bold', cursor: 'pointer', backgroundColor: '#edf2f7', outline: 'none', textAlign: 'inherit' };
const innerStyle: React.CSSProperties = { padding: '12px', fontSize: '13px', color: '#4a5568', lineHeight: '1.5', textAlign: 'inherit' };
const imgStyle: React.CSSProperties = { width: '100%', borderRadius: '6px', margin: '8px 0', border: '1px solid #cbd5e0' };
const imgMobileStyle: React.CSSProperties = { width: '130px', display: 'block', margin: '10px auto', borderRadius: '12px', border: '2px solid #2d3748' };
const badgeApp: React.CSSProperties = { fontSize: '9px', backgroundColor: '#48bb78', color: 'white', padding: '2px 6px', borderRadius: '4px', display: 'inline-block', fontWeight: 'bold' };
const badgePro: React.CSSProperties = { fontSize: '9px', backgroundColor: '#ecc94b', color: '#2d3748', padding: '2px 6px', borderRadius: '4px', display: 'inline-block', fontWeight: 'bold', marginTop: '5px' };
const xlsLinkStyle: React.CSSProperties = { color: '#2f855a', fontWeight: 'bold', fontSize: '13px', textDecoration: 'none', border: '1px solid #2f855a', padding: '8px 12px', borderRadius: '8px', display: 'inline-block', width: '200px' };
const listStyle: React.CSSProperties = { paddingLeft: '18px', margin: '8px 0' };
const modalStyle: React.CSSProperties = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 11000, display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'zoom-out' };
const fullImgStyle: React.CSSProperties = { maxWidth: '90%', maxHeight: '90%', borderRadius: '10px', boxShadow: '0 0 30px rgba(0,0,0,0.5)', cursor: 'default' };
const closeZoom: React.CSSProperties = { position: 'absolute', top: '20px', right: '30px', color: 'white', fontSize: '45px', fontWeight: 'bold', cursor: 'pointer' };